import React from "react";
import { Iprops } from "./itemincartinterface";
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../const/resource";
import Alerts from "../../Alerts";
import CartExcelExport from "../CartExcelExport/cartexcelexport";
import helperfunctions from "../../../utils/helperfunctions";
import { useCartContext } from "../shoppingcart";
import { ICartContextType } from "../ShoppingCartPromo/shoppingcartpromointerface";
import partsService from "../../../services/partsservice";

const Download = (props: any) => {
  const exportRef = React.createRef<any>();
  const { t } = useTranslation();
  const isDisabled = (props?.cartsDetails?.parts?.length ?? 0) == 0;
  const convertToNumber = (input: any) => {
    const number = input ? Number(input) : 0;
    return number;
  };
  const { itemSummaryDetails }: ICartContextType = useCartContext();
  const creditApplied = convertToNumber(
    itemSummaryDetails?.data?.komatsuCredit
  );
  const total = convertToNumber(itemSummaryDetails?.data?.total);
  const { isPromoCodeApplied, promoDetailList, isKomatsuCreditApplied } =
    props?.itemSummaryDetails?.data ?? {};

  const onDownload = () => {
    if (exportRef?.current) {
      let workbook = exportRef?.current?.workbookOptions();
      if (isPromoCodeApplied || isKomatsuCreditApplied) {
        workbook?.sheets[0].rows.push({
          cells: [
            {
              background: "#d3d3d3",
              colSpan: 5,
            },
            {
              value: t(RESOURCE.MyK_Label_SC_Parts_Total),
              background: "#d3d3d3",
              hAlign: "right",
            },
            {
              background: "#d3d3d3",
            },
            {
              background: "#d3d3d3",
            },
            {
              value: `$${helperfunctions.formatAmount(
                convertToNumber(props?.itemSummaryDetails?.data?.subtotal)
              )}`,
              background: "#d3d3d3",
              hAlign: "right",
            },
            {
              background: "#d3d3d3",
            },
          ],
        });
      }
      if (isPromoCodeApplied && promoDetailList?.length > 0) {
        workbook?.sheets[0].rows.push({
          cells: [
            {
              background: "#d3d3d3",
              colSpan: 5,
            },
            {
              value: t(RESOURCE.MyK_Label_SC_PromoCode_Applied),
              background: "#d3d3d3",
              hAlign: "right",
            },
            {
              background: "#d3d3d3",
            },
            {
              background: "#d3d3d3",
            },
            {
              background: "#d3d3d3",
            },
            {
              background: "#d3d3d3",
            },
          ],
        });
        promoDetailList.map((promo: any) => {
          workbook?.sheets[0].rows.push({
            cells: [
              {
                background: "#d3d3d3",
                colSpan: 5,
              },
              {
                value: promo?.promoCode,
                background: "#d3d3d3",
                hAlign: "right",
              },
              {
                background: "#d3d3d3",
              },
              {
                background: "#d3d3d3",
              },
              {
                value: `($${helperfunctions.formatAmount(
                  promo?.discountPrice
                )})`,
                background: "#d3d3d3",
                hAlign: "right",
              },
              {
                background: "#d3d3d3",
              },
            ],
          });
        });
      }
      if (isKomatsuCreditApplied) {
        workbook?.sheets[0].rows.push({
          cells: [
            {
              background: "#d3d3d3",
              colSpan: 5,
            },
            {
              value: t(RESOURCE.MyK_Label_SC_Parts_Credit_Applied),
              background: "#d3d3d3",
              hAlign: "right",
            },
            {
              background: "#d3d3d3",
            },

            {
              background: "#d3d3d3",
            },
            {
              value: `($${helperfunctions.formatAmount(creditApplied)})`,
              background: "#d3d3d3",
              hAlign: "right",
            },
            {
              background: "#d3d3d3",
            },
          ],
        });
      }
      workbook?.sheets[0].rows.push({
        cells: [
          {
            background: "#d3d3d3",
            colSpan: 5,
          },
          {
            value:
              isPromoCodeApplied || isKomatsuCreditApplied
                ? t(RESOURCE.MyK_Label_SC_Discount_SubTotal)
                : t(RESOURCE.MyK_Label_ShoppingCart_Sub_Total),
            background: "#d3d3d3",
            hAlign: "right",
          },
          {
            background: "#d3d3d3",
          },
          {
            background: "#d3d3d3",
          },
          {
            value: `$${helperfunctions.formatAmount(total)}`,
            background: "#d3d3d3",
            hAlign: "right",
          },
          {
            background: "#d3d3d3",
          },
        ],
      });
      exportRef?.current.save(workbook);
      }

      const model = {
          userId: props?.cartsDetails?.cart?.userAadId,
          eventData: `OrderId:${props?.cartsDetails?.cart?.cartId}`,
          eventName: "CartExportedToExcel"
      }

      partsService.eventAuditLogForDownload(model).then();
  };

  return (
    <>
      <button
        className={`custom_lineBtn ${isDisabled ? "disabled" : ""}`}
        onClick={onDownload}
        title={t(RESOURCE.MyK_Label_ShoppingCart_Download)}
      >
        {t(RESOURCE.MyK_Label_ShoppingCart_Download)}
      </button>
      <CartExcelExport
        cartData={props?.cartsDetails?.parts}
        cartExcelRef={exportRef}
      ></CartExcelExport>
    </>
  );
};

const IteminCart = (props: Iprops) => {
  const { t } = useTranslation();
  const { isGuestUser }: ICartContextType = useCartContext();

  const isDisabled = (props?.cartsDetails?.parts?.length ?? 0) == 0;
  const selectedParts = Object.values(props?.childCheckboxes ?? []).filter(
    (value) => value === true
  );
  const isSelectAllDisabled =
    (selectedParts?.length ?? 0) == (props?.cartsDetails?.parts?.length ?? 0);

  const getButtonClass = () => {
    return `custom_lineBtn ${isDisabled ? "disabled" : ""}`;
  };

  return props.cartToolMenu ? null : (
    <div>
      {props?.showAlert && (
        <Alerts
          messageAlert={props?.errorSuccessMessage}
          alertType={props?.alertType}
          time={3000}
          onClose={() => {
            props?.handleErrorClose();
          }}
        />
      )}
      <div className="item_cart-Section">
        <div className="leftBtns_item-cart">
          <span className="item_in-Cart">
            {props?.cartsDetails?.parts?.length ?? 0}{" "}
            {props?.cartsDetails?.parts?.length > 1
              ? t(RESOURCE.MyK_Label_ShoppingCart_ItemsInCart)
              : t(RESOURCE.MyK_Label_ShoppingCart_ItemInCart)}
          </span>
          <button
            className={`item_select-All ${
              (isSelectAllDisabled || isDisabled) ? "disabled" : null
            }`}
            disabled={isSelectAllDisabled || isDisabled}
            title={t(RESOURCE.MyK_Label_ShoppingCart_Select_All)}
            onKeyDown={() => {}}
            onClick={() => {
              props.handleParentChange();
            }}
          >
            {t(RESOURCE.MyK_Label_ShoppingCart_Select_All)}
          </button>
          <button
            className={`item_deselect-All ${
              (!isSelectAllDisabled || isDisabled) ? "disabled" : null
            }`}
            disabled={!isSelectAllDisabled || isDisabled}
            title={t(RESOURCE.MyK_Label_ShoppingCart_Deselect_All)}
            onKeyDown={() => {}}
            onClick={props.handleDeselectAll}
          >
            {t(RESOURCE.MyK_Label_ShoppingCart_Deselect_All)}
          </button>
        </div>
        <div className="rightBtns_item-cart ml-auto">
          <Download {...props} />
          {!isGuestUser && <><button
            onClick={() => props.SaveOnClick()}
            className={getButtonClass()}
            title={t(RESOURCE.MyK_Label_Save)}
          >
            {t(RESOURCE.MyK_Label_Save)}
          </button>
          <button
            onClick={() => props.ShareOnClick()}
            className={getButtonClass()}
            title={t(RESOURCE.MyK_Label_Share)}
          >
            {t(RESOURCE.MyK_Label_Share)}
          </button></>}
          <button
            onClick={() => {
              props?.DeleteOnClick();
            }}
            className={getButtonClass()}
            title={t(RESOURCE.MyK_Label_Delete)}
          >
            {t(RESOURCE.MyK_Label_Delete)}
          </button>
        </div>
      </div>
    </div>
  );
};

export default IteminCart;
